import { Navbar } from "../shared/components/Navbar.tsx"
import { DashedLine } from "../shared/components/DashedLine.tsx"
import { useLanguage } from "../shared/context/LanguageContext.tsx";

export function AboutUs() {
    const { translation } = useLanguage();

    const aboutNowpayContent = [
        {
            title: translation.aboutNowpay,
            description: translation.aboutNowpayDesc,
        },
        {
            title: translation.servicesPricing,
            description: translation.aboutNowpayDesc,
        },
        {
            title: translation.deliveryShipmentPolicy,
            description: translation.deliveryShipmentPolicyDesc,
        },
        {
            title: translation.refundPolicy,
            description: translation.refundPolicyDesc,
        },
        {
            title: translation.noRefundPolicy,
            description: translation.noRefundPolicyDesc,
        },
        {
            title: translation.refundConditions,
            description: translation.refundConditionsDesc,
        },
    ]
    
    return (
        <main>
            <div className="sticky top-5 sm:top-0 md:relative z-50 mx-5 md:mx-7 lg:mx-10 xl:mx-[3.125rem] bg-secondary rounded-3xl">
                <Navbar />
            </div>
            <div className="flex flex-col gap-5 px-5 md:gap-9 md:py-9 md:px-9 lg:flex-row lg:gap-20 lg:py-0 lg:pt-[4.375rem] lg:px-[5.625rem]">
                <div className="min-w-[25%] text-[1.75rem] md:text-3xl lg:text-[2.5rem] font-bold px-5 pt-9 lg:px-0 lg:pt-0 text-primary !leading-[130%]">{translation.aboutUs}</div>
                <div className="flex flex-col gap-5 md:gap-6 lg:gap-[1.875rem] px-5 lg:px-0 pb-[1.875rem] ld:pb-0">
                    {aboutNowpayContent.map((item, index) => (
                        <div key={index} className="flex flex-col gap-5 md:gap-6 lg:gap-[1.875rem]">
                            <div className="flex flex-col gap-2.5">
                                <div className="text-base font-bold md:text-lg lg:text-[1.375rem] text-primary !leading-[130%] lg:leading-9">
                                    {item.title}
                                </div>
                                {Array.isArray(item.description) ? item.description.map((desc, i) => (
                                    <li key={i} className="text-base font-normal md:text-lg lg:text-[1.375rem] text-black ms-6 md:ms-7 lg:ms-8 !leading-[130%] lg:leading-9">
                                        {desc}
                                    </li>
                                )) : (
                                    <div className="text-base font-normal md:text-lg lg:text-[1.375rem] text-black !leading-[130%] lg:leading-9">
                                        {item.description}
                                    </div>
                                )}
                            </div>
                            {index !== aboutNowpayContent.length - 1 && <DashedLine key={index} />}
                        </div>
                    ))}
                </div>
            </div>
        </main>
    )
}